import { render, staticRenderFns } from "./ReviewCustomerDetailsAddress.vue?vue&type=template&id=e4a52276&"
import script from "./ReviewCustomerDetailsAddress.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerDetailsAddress.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCustomerDetailsAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports